import React from "react";
import {
  Container,
  Box,
  makeStyles,
  Button,
  Grid,
  Card,
  Typography,
} from "@material-ui/core";

const useStyle = makeStyles((theme) => ({
  cardBox: { boxShadow: "0 0 2rem 0 rgb(136 152 170 / 15%)" },
}));

export default function JoinGroup() {
  const classes = useStyle();
  return (
    <Box my={8}>
      <Container maxWidth="lg">
        <Grid container spacing={4}>
          <Grid item xs={12} md={6} lg={4}>
            <Card elevation={0} className={classes.cardBox}>
              <img
                src="https://source.unsplash.com/600x350/?nature,water"
                width="100%"
                alt=""
              />
              <Box p={2}>
                <Typography variant="h4" gutterBottom>
                  Strategic Sale
                </Typography>
                <Typography color="textSecondary" variant="body2" paragraph>
                  by John Snow on Oct 29th at 10:23 AM
                </Typography>
                <Typography paragraph>
                  eligendi nemo iure repellat, soluta, optio minus ut reiciendis
                  voluptates enim impedit veritatis officiis.
                </Typography>
                <Button
                  color="primary"
                  variant="contained"
                  onClick={() => {
                    window.open(
                      `https://telegram.me/collablandbot?start=VFBDI1RFTCNDT01NIy0xMDAxNDIxNTk3MjE1`,
                      "_blank"
                    );
                  }}
                >
                  Join
                </Button>
              </Box>
            </Card>
          </Grid>
          <Grid item xs={12} md={6} lg={4}>
            <Card elevation={0} className={classes.cardBox}>
              <img
                src="https://source.unsplash.com/600x350/?nature,water"
                width="100%"
                alt=""
              />
              <Box p={2}>
                <Typography variant="h4" gutterBottom>
                  Private Sale 1
                </Typography>
                <Typography color="textSecondary" variant="body2" paragraph>
                  by John Snow on Oct 29th at 10:23 AM
                </Typography>
                <Typography paragraph>
                  eligendi nemo iure repellat, soluta, optio minus ut reiciendis
                  voluptates enim impedit veritatis officiis.
                </Typography>
                <Button
                  color="primary"
                  variant="contained"
                  onClick={() => {
                    window.open(
                      `https://telegram.me/collablandbot?start=VFBDI1RFTCNDT01NIy0xMDAxNDIxNTk3MjE1`,
                      "_blank"
                    );
                  }}
                >
                  Join
                </Button>
              </Box>
            </Card>
          </Grid>
          <Grid item xs={12} md={6} lg={4}>
            <Card elevation={0} className={classes.cardBox}>
              <img
                src="https://source.unsplash.com/600x350/?nature,water"
                width="100%"
                alt=""
              />
              <Box p={2}>
                <Typography variant="h4" gutterBottom>
                  Private Sale 2
                </Typography>
                <Typography color="textSecondary" variant="body2" paragraph>
                  by John Snow on Oct 29th at 10:23 AM
                </Typography>
                <Typography paragraph>
                  eligendi nemo iure repellat, soluta, optio minus ut reiciendis
                  voluptates enim impedit veritatis officiis.
                </Typography>
                <Button
                  color="primary"
                  variant="contained"
                  onClick={() => {
                    window.open(
                      `https://telegram.me/collablandbot?start=VFBDI1RFTCNDT01NIy0xMDAxNDIxNTk3MjE1`,
                      "_blank"
                    );
                  }}
                >
                  Join
                </Button>
              </Box>
            </Card>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
}
